import { Footer } from "./footer";
import { colors, Menu, MenuItem, Navbar } from "./navbar";

export function Layout({
  menu = [],
  profileMenu,
  color,
  children,
  name,
  logoUrl,
  availableLanguages,
  onLanguageChange,
  showSearch = true,
  searchValue,
  onSearch,
}: {
  menu?: MenuItem[];
  profileMenu?: Menu[];
  color: keyof typeof colors;
  children: React.ReactNode;
  name: string;
  logoUrl?: string;
  availableLanguages?: string[];
  onLanguageChange?: (language: string) => void;
  showSearch?: boolean;
  searchValue?: string;
  onSearch?: (query: string) => void;
}) {
  return (
    <div className="min-h-dvh flex flex-col">
      <Navbar
        availableLanguages={availableLanguages}
        color={color}
        logoImgUrl={logoUrl}
        menu={menu}
        name={name}
        profileMenu={profileMenu}
        searchValue={searchValue}
        showSearch={showSearch}
        onLanguageChange={onLanguageChange}
        onSearch={onSearch}
      />
      <main className="flex flex-1 my-5 mx-5">{children}</main>
      <Footer />
    </div>
  );
}
